import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PercentageFieldText } from '../../mui-overrides/Percentage';

interface Props {
  disabled?: boolean;
}

export const YieldNumberField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext();

  return (
    <PercentageFieldText
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.issuingdetails.fields.yield')}
      fieldName="investmentDetails.yield"
      formik={formik}
    />
  );
};
